import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-cream border-y border-sage/10" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-133">
        <div className="inline-flex items-center justify-center p-4 bg-white rounded-full shadow-sm mb-6" data-id="element-134">
          <ShieldCheck className="h-10 w-10 text-sage" data-id="element-135" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-forest mb-4" data-id="element-136">
          Garantía de satisfacción — 7 días
        </h2>

        <p className="text-lg text-forest/70 max-w-2xl mx-auto" data-id="element-137">
          Queremos que te sientas segura con tu compra. Si la guía no te resulta
          útil o no es lo que esperabas, te devolvemos tu dinero. Sin preguntas
          complicadas.
        </p>
      </div>
    </section>;
}